module.exports = __webpack_public_path__ + "img/boominggames.b1de8185.svg";